
// initial state
const state = {
  alerts: []
}

// getters
const getters = {}

// actions
const actions = {
  // dummy ({ commit, state, rootState }) {
  // }
}

// mutations
const mutations = {
  pushAlert (state, alert) {
    state.alerts.push(alert)
  },
  removeAlert (state, index) {
    console.log('in removeAlert', state.alerts, index)
    state.alerts.splice(index, 1)
  }
}

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/alerts.js